export const getModalWidth = (clientsCount: number) => {
  if (clientsCount >= 3) {
    return 1136;
  }
  return 860;
};
